import {SharedConfig} from 'shared/lib/shared.config.interface';
import {environment} from '../environments/environment';
import { VERSION } from '../environments/version';

export const sharedConfig: SharedConfig = {
	production: environment.production,
	storagePrefix: `${environment.storagePrefix}/${VERSION.version.replace(/\./g, '')}`,
	http: {
		apiUrl: environment.apiUrl,
		mockUrl: environment.mockApi
	}
};
